export const formatDate = (date: string) => {
  const [day, month, year] = date.split('/');
  return `${year}-${month}-${day}T00:00:00Z`;
};
